import { render } from "./Favourites.vue?vue&type=template&id=4978809c&scoped=true"
const script = {}

import "./Favourites.vue?vue&type=style&index=0&id=4978809c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4978809c"]])

export default __exports__